module.exports = "\n<alg-tooltip-content\n  [isInModal]=\"true\"\n  [product]=\"product\"\n  [greenEnergy]=\"greenEnergy\">\n</alg-tooltip-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/custom-modal/custom-modal.component.html
// module id = ./src/app/components/dialogs/custom-modal/custom-modal.component.html
// module chunks = main